<template>
  <div class="group">
    <b-row>
    <b-list-group>
      <b-list-group-item style="text-align: center; font-size: 16px;">
        Purchase Req
      </b-list-group-item>
      <b-list-group-item class="bg-w">
        <a href="#"><a-icon type="left" /><a-icon type="left" /></a> &nbsp;
         <a href="#"><a-icon type="right" /><a-icon type="right" /></a>
      </b-list-group-item>
      <b-list-group-item style="background: yellow">req type manual</b-list-group-item>
      <b-list-group-item>cancel rej is yes</b-list-group-item>
    </b-list-group>
  </b-row>
  </div>
</template>

<script>
export default {
  name: 'WalkNav',
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.group .list-group{
      margin-left: 25px;
    margin-top: 15px;
    border: 1px solid #333;
    width: 225px;
    padding: 0;
}
.list-group-item{
  background: transparent;
  text-align: center;
      border: 2px solid #fff;
    padding: 0rem;
    font-size: 12px;
    font-weight: 600;
}
.group .list-group-item img{
  border-right: 2px solid #fff;
    padding: 0px 25px 0px 5px;
    background: #bbc7d6;
}
</style>
